module.exports = __webpack_public_path__ + "img/89.816bf37c.jpg";